<template>
  <div class="product-banner">
    <img :src="productBanner" alt="" />
    <div class="absolute">
      <div class="title">产品中心</div>
      <div class="text">
        科技创造智慧生活，软硬一体化打通线上线下
        ，全场景业务监管，赋能物业居委，三端协同，数据同步，让物业办事更有效率。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience v-if="experienceShow" :experienceShow="experienceShow" @experienceClick="experienceClick"></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from '../../../components/pc/components/Experience.vue'

import productBanner from "../../../assets/product/productBanner.png";

export default {
  setup() {
    return reactive({
      productBanner: productBanner,
      experienceShow: false
    });
  },
  components: {
    Experience
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow
    }
  },
};
</script>

<style scoped>
.product-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .product-banner {
    min-width: 1180px;
  }
}
.product-banner img {
  width: 100%;
  height: 628px;
}
.absolute {
  position: absolute;
  top: 30%;
  left: 34%;
  transform: translate(-50%, -50%);
}
.absolute .title {
  font-size: 30px;
  color: #248EFB;
}
.absolute .text {
  width: 490px;
  font-size: 14px;
  margin-top: 30px;
  color: #248EFB;
}
.absolute .experience {
  margin-top: 60px;
  font-size: 16px;
  color: #248EFB;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #248EFB;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
